import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { Router, ActivatedRoute } from "@angular/router";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import * as moment from 'moment';
import { ApiIntegration } from '../../_services/api.integration';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-shopify-user-create',
  templateUrl: './shopify-user-create.component.html',
  styleUrls: ['./shopify-user-create.component.css']
})
export class ShopifyUserCreateComponent implements OnInit {
  productImage: string = "/assets/images/default-product.png";
  instructions: string = 'N';
  errorMessage: string;
  imageUrl: string;
  uploadImage: string;
  hostNamePrefix: string;
  userName: string;
  passWord: string;
  hostName: string;
  statusText: string;
  statusText1: string;
  statusText2: string;
  statusText22: string;
  statusText11: string;
  channelNameShopify: string;
  apiKey: string;
  storeId: any;
  selectedId: string;

  constructor(private alertService: AlertService, private api: ApiIntegration, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute, public g: Globals) {
    this.g.page = "Create Store Management";
    this.hostNamePrefix = "https://";
    this.selectedId = this.route.snapshot.params['id']
  }

  ngOnInit() {
  }

  typeApiKey() {
    this.statusText11 = "";
    if (this.apiKey == '' || this.apiKey === null || this.apiKey === undefined || this.apiKey === 'undefined') {
      this.statusText11 = 'Please enter API key';
    }
  }

  typePassword() {
    this.statusText1 = "";
    if (this.passWord == '' || this.passWord === null || this.passWord === undefined || this.passWord === 'undefined') {
      this.statusText1 = 'Please enter password';
    }
  }

  typeHostName() {
    this.statusText2 = "";
    if (this.hostName == '' || this.hostName === null || this.hostName === undefined || this.hostName === 'undefined') {
      this.statusText2 = 'Please enter hostname';
    } else if (this.hostName.search("https://") > -1) {
      this.statusText2 = 'Please enter with out https://';
    }
  }

  showInstructions() {
    this.instructions = 'Y';
  }

  submitShopify() {
    this.g.loaderDisplay = "display";
    this.statusText11 = "";
    this.statusText22 = "";
    this.statusText1 = "";
    this.statusText2 = "";
    if (this.channelNameShopify == '' || this.channelNameShopify === null || this.channelNameShopify === undefined || this.channelNameShopify === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
    if (this.apiKey == '' || this.apiKey === null || this.apiKey === undefined || this.apiKey === 'undefined') {
      this.statusText11 = 'Please enter api key';
    }
    if (this.passWord == '' || this.passWord === null || this.passWord === undefined || this.passWord === 'undefined') {
      this.statusText1 = 'Please enter password';
    }

    if (this.hostName == '' || this.hostName === null || this.hostName === undefined || this.hostName === 'undefined') {
      this.statusText2 = 'Please enter hostname';
    } else if (this.hostName.search("https://") > -1) {
      this.statusText2 = 'Please enter with out https://';
    }
    if (this.statusText22 != "" || this.statusText11 != "" || this.statusText1 != "" || this.statusText2 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/toStoreMagentoCredentials', {
      "accountOwnerId": this.user.accountOwnerId,
      "hostName": this.hostNamePrefix + this.hostName,
      "connectionName": this.channelNameShopify,
      "organizationId": 1,
      "clientSecret": this.passWord,
      "storeType": "SHOPIFY",
      "apiKey": this.apiKey,
      "brandImageUrl": this.imageUrl
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shopify', 'Submitted Successfully');
          this.router.navigate(['/admin/storeIntegrations']);
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }


  verifyShopify() {
    this.g.loaderDisplay = "display";
    this.statusText11 = "";
    this.statusText22 = "";
    this.statusText1 = "";
    this.statusText2 = "";
    if (this.channelNameShopify == '' || this.channelNameShopify === null || this.channelNameShopify === undefined || this.channelNameShopify === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
    if (this.apiKey == '' || this.apiKey === null || this.apiKey === undefined || this.apiKey === 'undefined') {
      this.statusText11 = 'Please enter api key';
    }
    if (this.passWord == '' || this.passWord === null || this.passWord === undefined || this.passWord === 'undefined') {
      this.statusText1 = 'Please enter password';
    }

    if (this.hostName == '' || this.hostName === null || this.hostName === undefined || this.hostName === 'undefined') {
      this.statusText2 = 'Please enter hostname';
    } else if (this.hostName.search("https://") > -1) {
      this.statusText2 = 'Please enter with out https://';
    }
    if (this.statusText22 != "" || this.statusText11 != "" || this.statusText1 != "" || this.statusText2 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyShopifyConnection/', {
      "hostName": this.hostNamePrefix + this.hostName,
      "apiKey": this.apiKey,
      "secretKey": this.passWord
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Shopify', 'Connected Successfully');
          this.submitShopify();
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

  typechannelNameShopify() {
    this.statusText22 = "";
    if (this.channelNameShopify == '' || this.channelNameShopify === null || this.channelNameShopify === undefined || this.channelNameShopify === 'undefined') {
      this.statusText22 = 'Please enter Channel Name';
    }
  }

  loadImage(event) {
    this.productImage = URL.createObjectURL(event.target.files[0]);
    this.uploadImage = event.target.files[0];
    this.errorMessage = "";
    this.submitImage();
  }

  ignoreImage() {
    this.productImage = "/assets/images/default-product.png";
    this.uploadImage = null;
    this.imageUrl = null;
    this.errorMessage = "";
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imageUrl = data['message'];
      } else {
        this.imageUrl = "";
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
  }
}
